import { useState, useEffect, useRef } from 'react';
import { ReactComponent as CameraIcon } from 'assets/icons/camera.svg';
import styles from './UploadVideo.module.scss';

type Props = {
    src: string;
    getImageFile?: (file: File) => void;
};

const UploadVideo = ({ src, getImageFile }: Props) => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [image, setImage] = useState<string | ArrayBuffer | null>(null);
    const imgPickerRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        setImage(src);
    }, [src]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file: File | null = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);

        if (getImageFile && file) {
            getImageFile(file);
        }

        const fileData: FileReader = new FileReader();
        fileData.onloadend = handleFile;

        if (file) {
            fileData.readAsDataURL(file);
        }
    };

    const pickFile = () => {
        if (imgPickerRef) {
            imgPickerRef.current?.click();
        }
    };

    const handleFile = (ev: ProgressEvent<FileReader>) => {
        if (ev?.target) {
            const content: string | ArrayBuffer | null = ev.target.result;
            setImage(content);
        }
    };

    return (
        <div className={styles.root}>
            <div className={styles['img-wrapper']}>
                <input
                    className={styles.fileInput}
                    ref={imgPickerRef}
                    type="file"
                    accept="video/*, .mp4, .mkv,"
                    onChange={handleChange}
                />
                {!selectedFile && !src && (
                    <iframe
                        src="https://player.vimeo.com/video/489447933?h=06e051705b&title=0&byline=0&portrait=0"
                        width="356"
                        height="237"
                        allow="fullscreen"
                        title="Profile video placeholder"
                    />
                )}
                {(selectedFile || src) && (
                    <video src={image as string} controls height="237" width="356" />
                )}
            </div>
            <button className={styles['pick-img-btn']} onClick={pickFile}>
                <CameraIcon />
            </button>
        </div>
    );
};

export default UploadVideo;
